import React, { Component } from "react";
import { FormControl, FormHelperText } from "material-ui/Form";
import CircularProgressbar from "react-circular-progressbar";
import { API_URL } from "../../../util/constants";
import "./index.css";
import IS_CLIENT_RENDERED from "../../../util/isClientRendered";

class ImgUpload extends Component {
  constructor(props) {
    super(props);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.initializeUploader = this.initializeUploader.bind(this);
    this.initializeUploader();
    this.state = {
      progress: 0,
      isUploading: false,
    };
  }
  initializeUploader() {
    let sasUrl = `${API_URL}/api/v1/uploads/profile-pictures/sas`;

    if (IS_CLIENT_RENDERED) {
      const qq = require("fine-uploader/lib/azure");
      this.uploader = new qq.azure.FineUploaderBasic({
        signature: {
          endpoint: sasUrl,
          customHeaders: _ => ({
            Authorization: `Bearer ${this.props.accessToken}`,
          }),
        },
        retry: {
          enableAuto: true,
        },
        callbacks: {
          onComplete: (id, name, { success }) => {
            if (success) {
              this.setState(prevState => ({ isUploading: false }));
              //remove image sizing ex: /m and replace it with /temp
              const newValue = this.props.input.value
                .split("/")
                .slice(0, -1)
                .concat(["temp"])
                .join("/");
              this.props.input.onChange(newValue + `?q=${Date.now()}`);
            }
          },
          onProgress: (id, name, uploadedBytes, totalBytes) => {
            let percentage = (uploadedBytes / totalBytes) * 100;
            this.setState(prevState => ({
              ...prevState,
              progress: Math.floor(percentage),
            }));
          },
          onError: (id, name, errorReason, xhrOrXdr) => {
            this.setState(prevState => ({ ...prevState, isUploading: false }));
          },
        },
      });
    }
  }
  handleFileChange(e) {
    e.preventDefault();
    this.setState(prevState => ({ isUploading: true, progress: 0 }));
    this.uploader.addFiles(e.target.files);
  }

  render() {
    const {
      input,
      label,
      name,
      meta: { pristine },
    } = this.props;
    const { progress, isUploading } = this.state;

    return (
      <FormControl className="img-upload">
        <div className="progress-wrapper">
          {isUploading && <CircularProgressbar percentage={progress} />}
          <img className={`profile-img ${isUploading ? "-uploading" : ""}`} src={input.value} alt="profile" />
        </div>
        <div className="-select-photos-mobile">
          <input
            className="-inputfile"
            id="picture"
            name={name}
            type="file"
            onChange={this.handleFileChange}
            accept="image/*"
          />
          <label id="newCaseUploader" className="-select-button" htmlFor="picture">
            <a>Change Photo</a>
          </label>
        </div>
        {!pristine && (
          <FormHelperText className="form-helper-text">Note: The new image may take a while to appear.</FormHelperText>
        )}
      </FormControl>
    );
  }
}
export default ImgUpload;



// WEBPACK FOOTER //
// ./src/components/FormElements/ImgUpload/index.js